import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
// import { log } from 'sentry'
import { mediaQueries, mediaQueriesList } from '../constants'

export const isDevice = (check, match) => {
  if (!mediaQueries[check] && process.env.NODE_ENV !== 'production') {
    // log.warn(
    //   `device type "${check}" does not exist in specified devices: ${mediaQueriesList.join(', ')}`,
    // )
  }

  return mediaQueriesList.indexOf(check) <= mediaQueriesList.indexOf(match)
}

export const withDevice = (Component) => {
  const ConnectedComponent = (props) => {
    const deviceSize = useSelector((state) => state.device.screenType)

    return (
      <Component
        {...props}
        device={{
          name: deviceSize,
          is: (check) => isDevice(check, deviceSize),
        }}
      />
    )
  }

  ConnectedComponent.propTypes = {
    deviceSize: PropTypes.string,
  }

  ConnectedComponent.displayName = `withDevice(${Component.displayName ||
    Component.name ||
    'unknown'})`

  return ConnectedComponent
}
